export const trackOptIn = tracking =>
    tracking?.trackEvent({
        event: 'opt_in',
        opt_position: 'footer form',
        opt_value: true
    });
